import { render, staticRenderFns } from "./ModalDeleteItem.vue?vue&type=template&id=3f07bb88&scoped=true"
import script from "./ModalDeleteItem.vue?vue&type=script&lang=js"
export * from "./ModalDeleteItem.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteItem.vue?vue&type=style&index=0&id=3f07bb88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f07bb88",
  null
  
)

export default component.exports